import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { UigAccessSubjectAdapter } from './uig-access-subject.adapter';
import * as UigAccessSubjectActions from './uig-access-subject.action';
import { AccessSubjectList } from './uig-access-subject.model';

@Injectable()
export class UigAccessSubjectEffects {

  constructor(
    private actions$: Actions,
    private uigAccessSubjectAdapter: UigAccessSubjectAdapter
  ) { }

  getUigAccessSubject$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UigAccessSubjectActions.getUigAccessSubjectOverview),
      switchMap((action) =>
        this.uigAccessSubjectAdapter
          .getUigAccessSubject(
            action.params
          )
          .pipe(
            map((uigAccessSubjectOverview: AccessSubjectList) =>
              UigAccessSubjectActions.getUigAccessSubjectOverviewSuccess
                ({
                  uigAccessSubjectOverview,
                })
            ),
            catchError((error) =>
              of(
                UigAccessSubjectActions.getUigAccessSubjectOverviewFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });
}
